module.exports = {
      id: "icon-a-calendar-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-calendar",
      toString: function () {
        return this.url;
      }
    }